var _linearGradient, _linearGradient2, _linearGradient3, _linearGradient4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAlastria(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 455.444,
    height: 308.31,
    viewBox: "0 0 455.444 308.31",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.007,259.272l-.688,0a1.609,1.609,0,0,0-1.17.763l-9.878,21.851a1.078,1.078,0,0,0,.986,1.521l4.862-.018a1.077,1.077,0,0,0,.982-.642l4.333-9.821h.345l4.436,9.793a1.079,1.079,0,0,0,.985.634l4.968-.017a1.078,1.078,0,0,0,.977-1.526l-9.963-21.785a1.612,1.612,0,0,0-1.173-.755h0",
    style: {
      fill: "none"
    }
  })), _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: -193.223,
    y1: 451.795,
    x2: -192.223,
    y2: 451.795,
    gradientTransform: "matrix(0, -24.136, -24.136, 0, 10927.343, -4380.269)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00ffec"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#395f8d"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "c",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M146.593,258.849l-.69,0a1.617,1.617,0,0,0-1.17.762l-9.875,21.85a1.078,1.078,0,0,0,.985,1.522l4.861-.016a1.076,1.076,0,0,0,.983-.643l4.331-9.821h.346L150.8,282.3a1.078,1.078,0,0,0,.986.633l4.969-.016a1.078,1.078,0,0,0,.976-1.526L147.768,259.6a1.612,1.612,0,0,0-1.173-.755h0",
    style: {
      fill: "none"
    }
  })), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: -193.223,
    y1: 451.795,
    x2: -192.223,
    y2: 451.795,
    gradientTransform: "matrix(0, -24.136, -24.136, 0, 11050.929, -4380.693)",
    xlinkHref: "#b"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "e",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M432.936,257.867h-.689a1.613,1.613,0,0,0-1.17.764L421.2,280.481a1.077,1.077,0,0,0,.985,1.521l4.861-.016a1.077,1.077,0,0,0,.983-.643l4.333-9.82.344,0,4.437,9.794a1.077,1.077,0,0,0,.985.633l4.968-.017a1.077,1.077,0,0,0,.976-1.526l-9.962-21.783a1.61,1.61,0,0,0-1.174-.755h0",
    style: {
      fill: "none"
    }
  })), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "f",
    x1: -193.223,
    y1: 451.795,
    x2: -192.223,
    y2: 451.795,
    gradientTransform: "matrix(0, -24.136, -24.136, 0, 11337.272, -4381.675)",
    xlinkHref: "#b"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "g",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 177.334,
    width: 102.067,
    height: 210.341,
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "h",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M224.078,80.7l-19.14,42.317-20.365,45.026a4.5,4.5,0,0,0,4.1,6.352h18.377a4.5,4.5,0,0,0,4.1-2.644l15.487-34.243a1.7,1.7,0,0,1,3.087,0l15.487,34.243a4.5,4.5,0,0,0,4.1,2.644h18.376a4.5,4.5,0,0,0,4.1-6.352L251.416,123.02,232.274,80.7a4.5,4.5,0,0,0-8.2,0",
    style: {
      fill: "none"
    }
  })), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "i",
    x1: -193.223,
    y1: 451.795,
    x2: -192.223,
    y2: 451.795,
    gradientTransform: "matrix(0, -96.339, -96.339, 0, 43753.869, -18440.607)",
    xlinkHref: "#b"
  }))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "09-alastria") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M80.053,282.349l-.072-21.021a1.315,1.315,0,0,0-1.315-1.306l-4.551.015a1.309,1.309,0,0,0-1.306,1.315l.072,21.021a1.078,1.078,0,0,0,1.081,1.075l5.017-.017a1.078,1.078,0,0,0,1.074-1.082",
    transform: "translate(0 0)",
    style: {
      fill: "#3d3c3c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.808,301.813l-18.688.064-.031-8.931a1.077,1.077,0,0,0-1.081-1.074l-5.016.017a1.078,1.078,0,0,0-1.075,1.081L72.965,307a1.31,1.31,0,0,0,1.316,1.306l24.549-.084a1.31,1.31,0,0,0,1.306-1.314l-.014-3.793a1.307,1.307,0,0,0-1.314-1.306",
    transform: "translate(0 0)",
    style: {
      fill: "#3d3c3c"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#a)"
    }
  }, /*#__PURE__*/React.createElement("rect", {
    x: 10.948,
    y: 259.272,
    width: 23.523,
    height: 24.139,
    style: {
      fill: "url(#b)"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M38.984,292.391a1.076,1.076,0,0,0-.983-.629l-6.68.023,0,.009-17.24.06,0-.01-6.636.023a1.077,1.077,0,0,0-.978.633L.137,306.521a1.217,1.217,0,0,0,1.179,1.789L5.66,308.3a1.731,1.731,0,0,0,1.582-1.04c1.369-3.176,2.806-6.285,4.175-9.462l22.549-.078,4.308,9.434a1.608,1.608,0,0,0,1.591,1.029l4.344-.016a1.216,1.216,0,0,0,1.166-1.8Z",
    transform: "translate(0 0)",
    style: {
      fill: "#3d3c3c"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#c)"
    }
  }, /*#__PURE__*/React.createElement("rect", {
    x: 134.535,
    y: 258.849,
    width: 23.521,
    height: 24.138,
    style: {
      fill: "url(#d)"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M162.57,291.967a1.081,1.081,0,0,0-.984-.63l-6.679.024,0,.009-17.24.06,0-.011-6.635.024a1.078,1.078,0,0,0-.979.633L123.722,306.1a1.218,1.218,0,0,0,1.179,1.789l4.344-.015a1.734,1.734,0,0,0,1.583-1.04c1.368-3.176,2.805-6.285,4.175-9.463l22.548-.077,4.309,9.434a1.6,1.6,0,0,0,1.591,1.028l4.344-.015a1.217,1.217,0,0,0,1.166-1.8Z",
    transform: "translate(0 0)",
    style: {
      fill: "#3d3c3c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.379,282.76l11.266-.038a.675.675,0,0,0,.279-1.288c-1.211-.57-2.478-1.108-3.777-1.629-5.732-2.324-8.774-4.729-8.788-8.659-.008-2.552,1.979-6.213,7.772-6.234,4-.013,8.838,3.143,9.321,3.417a1.63,1.63,0,0,0,2.411-.7c.549-.829,1.166-1.8,1.715-2.627a1.637,1.637,0,0,0-.422-2.343,23.367,23.367,0,0,0-12.771-4.024c-10.965.037-15.076,7.431-15.059,12.81a12.506,12.506,0,0,0,4.781,10.187,5.087,5.087,0,0,0,3.272,1.126",
    transform: "translate(0 0)",
    style: {
      fill: "#3d3c3c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.13,291.151a.774.774,0,0,0-.682,1.152,6.134,6.134,0,0,1,.926,3.271c.012,3.516-3.014,6.423-7.77,6.439-5.311.019-10.636-4.377-11.052-4.72a1.562,1.562,0,0,0-2.343.56c-.616.9-1.165,1.934-1.782,2.832a1.45,1.45,0,0,0,.421,2.206,22.325,22.325,0,0,0,14.845,5.4c8.965-.031,15.358-5.914,15.333-13.086a13.281,13.281,0,0,0-.35-3.047,1.331,1.331,0,0,0-1.3-1.025Z",
    transform: "translate(0 0)",
    style: {
      fill: "#3d3c3c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.514,265.667l11.241-.038.054,15.772a1.155,1.155,0,0,0,1.159,1.151l4.862-.017a1.153,1.153,0,0,0,1.151-1.158l-.054-15.773,11.24-.039a1.309,1.309,0,0,0,1.306-1.314l-.014-3.862a1.308,1.308,0,0,0-1.314-1.306l-29.653.1a1.31,1.31,0,0,0-1.306,1.314l.014,3.862a1.308,1.308,0,0,0,1.314,1.306",
    transform: "translate(0 0)",
    style: {
      fill: "#3d3c3c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.846,292.152l.048,13.957a1.314,1.314,0,0,0,1.314,1.306l4.552-.015a1.315,1.315,0,0,0,1.306-1.315l-.048-13.957a1.154,1.154,0,0,0-1.158-1.151l-4.864.017a1.154,1.154,0,0,0-1.15,1.158",
    transform: "translate(0 0)",
    style: {
      fill: "#3d3c3c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.911,281.213l-.053-15.566,12.18-.041a8.4,8.4,0,0,1,8.533,7.932,8.607,8.607,0,0,1-4.636,7.883.471.471,0,0,0,.216.891l8.078-.029a1.079,1.079,0,0,0,.877-.444,13.975,13.975,0,0,0,2.64-8.22,14.879,14.879,0,0,0-15.084-14.706l-18.757.065a1.31,1.31,0,0,0-1.306,1.314l.073,20.945a1.154,1.154,0,0,0,1.158,1.151l4.931-.017a1.153,1.153,0,0,0,1.15-1.158",
    transform: "translate(0 0)",
    style: {
      fill: "#3d3c3c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.859,290.829a1.155,1.155,0,0,0-1.15,1.159l.047,13.957a1.31,1.31,0,0,0,1.316,1.306l4.481-.015a1.314,1.314,0,0,0,1.306-1.315l-.048-13.957a1.153,1.153,0,0,0-1.158-1.151Z",
    transform: "translate(0 0)",
    style: {
      fill: "#3d3c3c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.578,290.745l-5.246.018a1.153,1.153,0,0,0-1.025,1.675l7.139,14.105a1.27,1.27,0,0,0,1.106.617l5.379-.019a1.3,1.3,0,0,0,1.165-2l-7.5-13.791a1.151,1.151,0,0,0-1.018-.6",
    transform: "translate(0 0)",
    style: {
      fill: "#3d3c3c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.4,281.062l-.072-21.022a1.315,1.315,0,0,0-1.315-1.306l-4.551.016a1.313,1.313,0,0,0-1.306,1.314l.072,21.022a1.078,1.078,0,0,0,1.081,1.075l5.017-.018a1.078,1.078,0,0,0,1.074-1.081",
    transform: "translate(0 0)",
    style: {
      fill: "#3d3c3c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.26,291.682l.049,14.035a1.315,1.315,0,0,0,1.314,1.306l4.551-.016a1.315,1.315,0,0,0,1.306-1.315l-.048-14.034a1.078,1.078,0,0,0-1.081-1.075l-5.017.018a1.078,1.078,0,0,0-1.074,1.081",
    transform: "translate(0 0)",
    style: {
      fill: "#3d3c3c"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#e)"
    }
  }, /*#__PURE__*/React.createElement("rect", {
    x: 420.878,
    y: 257.867,
    width: 23.522,
    height: 24.139,
    style: {
      fill: "url(#f)"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M448.912,290.985a1.079,1.079,0,0,0-.983-.63l-6.679.024,0,.009-17.24.06,0-.011-6.636.024a1.077,1.077,0,0,0-.978.633l-6.338,14.021a1.217,1.217,0,0,0,1.179,1.789l4.344-.015a1.731,1.731,0,0,0,1.582-1.04c1.369-3.176,2.806-6.285,4.175-9.463l22.549-.077,4.308,9.434a1.607,1.607,0,0,0,1.591,1.028l4.344-.015a1.216,1.216,0,0,0,1.166-1.8Z",
    transform: "translate(0 0)",
    style: {
      fill: "#3d3c3c"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.25
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#g)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M186.872,97.843l19.09-42.207L226.738,9.7A1.789,1.789,0,0,1,230,9.7l20.775,45.934,19.091,42.207a17.474,17.474,0,0,1,.753,1.981,1.6,1.6,0,0,0,1.53,1.126h5.638a1.609,1.609,0,0,0,1.573-1.971,26.136,26.136,0,0,0-1.612-4.7l-19.09-42.207L238.02,6.452A10.8,10.8,0,0,0,230.981.33a10.455,10.455,0,0,0-12.125,5.807L198.08,52.071,178.989,94.278a26.368,26.368,0,0,0-1.611,4.7,1.609,1.609,0,0,0,1.573,1.971h5.638a1.6,1.6,0,0,0,1.53-1.126,17.474,17.474,0,0,1,.753-1.981",
    transform: "translate(0 0)",
    style: {
      fill: "#09afba"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.863,112.5l-19.091,42.207L230,200.639a1.788,1.788,0,0,1-3.258,0l-20.776-45.934L186.873,112.5a17.474,17.474,0,0,1-.753-1.981,1.6,1.6,0,0,0-1.53-1.126h-5.638a1.609,1.609,0,0,0-1.573,1.971,26.21,26.21,0,0,0,1.611,4.7l19.091,42.207L218.857,204.2a10.455,10.455,0,0,0,12.124,5.807,10.806,10.806,0,0,0,7.04-6.122l20.634-45.619,19.09-42.207a26.293,26.293,0,0,0,1.612-4.7,1.609,1.609,0,0,0-1.573-1.971h-5.638a1.6,1.6,0,0,0-1.53,1.126,17.474,17.474,0,0,1-.753,1.981",
    transform: "translate(0 0)",
    style: {
      fill: "#09afba"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#h)"
    }
  }, /*#__PURE__*/React.createElement("rect", {
    x: 183.226,
    y: 78.058,
    width: 89.901,
    height: 96.34,
    style: {
      fill: "url(#i)"
    }
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlastria);
export default __webpack_public_path__ + "static/media/alastria.30c7ed5e89f08f27cb312e7a46f13f3d.svg";
export { ForwardRef as ReactComponent };